'use strict';

var chunk3CUP7X6U_js = require('./chunk-3CUP7X6U.js');
var l = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var l__default = /*#__PURE__*/_interopDefault(l);

function c(n){let{size:i,onClick:p,fill:r="#EF6E0B",rotateBy:o=0}=n,e={transform:typeof o=="string"?o:`rotate(${o}deg)`};return l__default.default.createElement(chunk3CUP7X6U_js.a,{size:i||"20px",viewBox:"0 0 20 20",fill:r,onClick:p,style:e},l__default.default.createElement("path",{d:"M17.317 10.442l-5.625 5.625a.625.625 0 11-.884-.884l4.558-4.558H3.125a.625.625 0 110-1.25h12.241l-4.558-4.558a.625.625 0 01.884-.884l5.625 5.625a.626.626 0 010 .884z",fill:r}))}

exports.a = c;
